import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ELanguage } from 'projects/ng-util/src/lib/i18n/enums/language.enum';
import { ValidationService } from './validation.service';

@Component({
  selector: 'control-messages',
  template: `<p *ngIf="errorMessage !== null" >{{errorMessage}}</p>`
})
export class CustomControlMessagesComponent {

  @Input() control: AbstractControl;
  @Input() locale: ELanguage = ELanguage.Portuguese;

  constructor() { }

  get errorMessage(): string {
    
    for (const propertyName in this.control.errors) {
      if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched)
        return ValidationService.getValidatorErrorMessage(
          propertyName, this.control.errors[propertyName], this.locale);
    }
    return '';
  }
}
